import { Action, ActionType, Aws } from "../model";
import createReducer from "./createReducer";

export const aws = createReducer({}, {
	[ActionType.SIGNED_URL](state: Aws, action: Action<Aws>) {
		return action.payload;
	},
});
